import React from 'react';
import { styled } from '@components-shared/src/stitches';
import type { Pathname } from '@components/main-components/link/AccessibleLink';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { activeStyles } from '../shared';

export const HeaderLink = ({
  label,
  pathnameUri,
  isActive = false,
  onClick,
}: {
  label: React.ReactNode;
  pathnameUri: Pathname;
  isActive: boolean;
  onClick?: () => void;
}) => {
  return (
    <Container pathnameUri={pathnameUri} isActive={isActive} onClick={onClick}>
      <div className="active-indicator absolute left-0 h-[26px] w-[3px] rounded-[0px_4px_4px_0px]" />
      <span className="font-title text-title-l font-medium text-base500">{label}</span>
    </Container>
  );
};

const Container = styled(AccessibleLink, {
  width: '100%',
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
  outline: '0 none',
  position: 'relative',
  span: {
    transition: 'color 0.3s ease',
  },
  '@laptop': {
    paddingLeft: 16,
    justifyContent: 'unset',
  },
  '&:focus-visible': {
    outline: '2px solid $base800',
    '.active-indicator': {
      backgroundColor: 'transparent',
    },
  },
  '&:hover': {
    cursor: 'pointer',
    border: 'none',
    span: {
      color: '$base800',
    },
  },
  '&:active': {
    ...activeStyles,
    '.active-indicator': {
      backgroundColor: 'transparent',
    },
  },
  variants: {
    isActive: {
      true: {
        ...activeStyles,
        span: {
          ...activeStyles,
        },
      },
    },
  },
});
